<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75ZM9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
            class="fill-current" />
        <path
            d="M4.83928 8.82741C4.59522 9.07147 4.5952 9.46722 4.83928 9.7113L7.49093 12.3629C7.73501 12.607 8.13075 12.607 8.37481 12.3629L13.6781 7.05965C13.9222 6.81559 13.9222 6.41984 13.6781 6.17576C13.434 5.93169 13.0383 5.9317 12.7942 6.17576L7.93287 11.0371L5.72316 8.82741C5.47909 8.58334 5.08334 8.58335 4.83928 8.82741Z"
            class="fill-current" />
    </svg>
</template>
